import { createFileRoute, Link } from "@tanstack/react-router";
import { AuthCard } from "@/routes/auth/_auth-layout/-components/auth/auth-card";

export const Route = createFileRoute("/auth/_auth-layout/signup/success")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthCard
      backTo="/auth/signin"
      title="Sign up successful"
      description="You will receive an email shortly with instructions on how to log in to your account."
      footer={
        <Link
          to="/auth/signin"
          className="font-semibold text-volume-text-purple hover:underline"
        >
          Sign in now
        </Link>
      }
    />
  );
}
